import { Outlet, createFileRoute } from '@tanstack/react-router'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/chat',
)({
  component: function IsaChatLayoutRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.IA_TOOLS} dashboardId={dashboardId}>
        <ProtectedRoute
          anyOf={[CAPABILITIES.CONTATOS_ALL, CAPABILITIES.CONTATOS_OWN]}
          dashboardId={dashboardId}
        >
          <Outlet />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
